export default __webpack_public_path__ + "static/esku1-d529e51cc99de13f2aa900c88e690cce.png";